import React from 'react';import PropTypes from 'prop-types';
import classnames from 'classnames';

const getProductLabelClass = isToCancel => classnames('row-fluid', 'productBoxLabel', {
    'text-active': isToCancel === false,
    'text-no-active': isToCancel === true
});
const getSerialNumberLabelClass = isToCancel => classnames('fontSizeSmall', {
    'text-active': isToCancel === false,
    'text-no-active': isToCancel === true
});

const ProductItem = ({ subscription }) => {
    const productLabelClass = getProductLabelClass(subscription.isToCancel);
    const serialNumberLabelClass = getSerialNumberLabelClass(subscription.isToCancel);
    return (
        <div>
            <div className={productLabelClass}>
                {subscription.name}
            </div>
            <div className={serialNumberLabelClass}>
                (Serienummer: {subscription.serialNumber})
            </div>
        </div>
    );
};

export default ProductItem;
